import type {OAuthError} from '@cohort/wallet/lib/oAuth';
import {OAuthErrorList} from '@cohort/wallet/lib/oAuth';
import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

export default function useOauthError(): [
  OAuthError | undefined,
  (error: OAuthError | undefined) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();
  const [oauthError, setOauthError] = useState<OAuthError | undefined>(() => {
    if (searchParams.has('error')) {
      const error = searchParams.get('error');

      return OAuthErrorList.includes(error as OAuthError) ? (error as OAuthError) : undefined;
    }
    return undefined;
  });

  useEffect(() => {
    if (searchParams.has('error')) {
      searchParams.delete('error');
      setSearchParams(searchParams, {replace: true});
    }
  }, [searchParams, setSearchParams]);

  return [oauthError, setOauthError] as const;
}
